export const SUPPORTED_COLORS = {
  red: '#EA3323',
  yellow: '#FFD954',
  blue: '#528DFF',
  black: '#000000',
  white: '#ffffff',
}
